// import React, { useRef, useState } from "react";
// import Layouts from "../../Layouts";
// import { FaXTwitter } from "react-icons/fa6";
// import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
// import { BsInstagram } from "react-icons/bs";
// import { CiMail } from "react-icons/ci";
// import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
// import getin from "../../../Assests/images/get in.jpg";
// import { Form, Input, InputNumber, message } from "antd";
// import TextArea from "antd/es/input/TextArea";
// import ContactService from "../../../Redux/Services/ContactService";

// function Contact() {
//   const formRef = useRef();
//   const facebookPageUrl = "https://www.facebook.com/your-facebook-page-url";
//   const twitterPageUrl = "https://twitter.com/your-twitter-page-url";
//   const instagramPageUrl = "https://www.instagram.com/your-instagram-page-url";
//   const linkedinPageUrl = "https://www.linkedin.com/in/the-venkataramana-ayurveda-dispensary-sri-v-krishnaswamy-iyer-charitable-trust-852a503a0/";

//   const handleKeyPress = (e) => {
//     const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
//     if (!allowedKeys.includes(e.key)) {
//       if (/^[A-Za-z]$/.test(e.key)) {
//         message.error("Alphabetic characters are not allowed.");
//       }
//       e.preventDefault();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const { name, email, phone, feedback } = formRef.current.getFieldValue();

//     if (name === "" || name === undefined || name === null) {
//       message.error("Please fill in all fields");
//       return;
//     }

//     if (email === "" || email === undefined || email === null) {
//       message.error("Please fill in all the fields");
//       return;
//     }

//     if (phone === "" || phone === undefined || phone === null) {
//       message.error("Please fill in all the fields");
//       return;
//     }

//     if (feedback === "" || feedback === undefined || feedback === null) {
//       message.error("Please fill in all the fields");
//       return;
//     }

//     const currDate = new Date().toISOString();
//     const date = currDate.split('T')[0];
//     const time = currDate.split('T')[1].slice(0, 8);
//     const constructedTime = date + " " + time;


//     let payload = {
//       address: "string",
//       code: "string",
//       createdBy: "string",
//       createdDate: constructedTime,
//       email,
//       mobileNumber: phone,
//       modifiedBy: "string",
//       modifiedDate: constructedTime,
//       status: 1
//     }

//     try {
//       await ContactService.contactUs(payload);
//       message.success("Thank You! Our support team will contact you shortly.");
//     }
//     catch (e) {
//       message.error("Error Occurred");
//     }
//   };


//   return (
//     <Layouts>
//       <div className="bg-[#FBFBFB]">
//         <div className="h-auto">
//           <div className=" relative">
//             <img className="w-full h-52 object-cover" src={getin} alt="" />
//             <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:text-[50px] text-xl font-black text-white">
//               Get in Touch!
//             </p>
//           </div>
//           <div className="flex items-center md:justify-center">
//             <div className="md:flex md:justify-center gap-4 md:p-5 p-5 bg-white shadow-lg md:w-[80%] w-full rounded-md md:mt-5 mb-5">
//               <section className="md:w-1/2 flex justify-center">
//                 <Form ref={formRef} className="w-full">

//                   <div className="">
//                     <label className="text-lg uppercase text-[#A17A17] font-medium">
//                       leave a message here
//                     </label>
//                     <p className="mt-1">Feel free to drop us a line below</p>
//                     <div className="grid md:w-full">
//                       <label className="mt-3">
//                         Name
//                         <span className=" text-red-500 text-md">*</span>
//                       </label>
//                       <Form.Item name="name">
//                         <Input
//                           // type="text"
//                           className="border border-gray-500 p-2 w-full rounded-md focus:outline-none"
//                           placeholder="Enter your Name"
//                           name="name"
//                           // value={formData.name}
//                           // onChange={handleChange}
//                           required
//                         />
//                       </Form.Item>

//                       {/* {errors.name && (
//                         <p className="absolute text-red-500">{errors.name}</p>
//                       )} */}
//                       <label className="mt-2">
//                         Email
//                         <span className=" text-red-500 text-md">*</span>
//                       </label>
//                       <Form.Item name="email">
//                         <Input
//                           // type="email"
//                           className="border border-gray-500 w-full p-2 rounded-md focus:outline-none"
//                           placeholder="Enter your Email"
//                           // name="email"
//                           // value={formData.email}
//                           // onChange={handleChange}
//                           required
//                         />

//                       </Form.Item>

//                       {/* {errors.email && (
//                         <p className="absolute text-red-500 ">{errors.email}</p>
//                       )}   */}

//                       <label className="mt-2">
//                         Mobile
//                         <span className=" text-red-500 text-md">*</span>
//                       </label>
//                       <Form.Item name="phone">
//                         <InputNumber
//                           onKeyPress={handleKeyPress}
//                           maxLength={10}
//                           // type="email"
//                           className="border border-gray-500 w-full p-2 rounded-md focus:outline-none"
//                           placeholder="Enter your Mobile No"
//                           // name="email"
//                           // value={formData.email}
//                           // onChange={handleChange}
//                           required
//                         />

//                       </Form.Item>


//                       <label className="mt-2">Message
//                         <span className=" text-red-500 text-md">*</span>
//                       </label>
//                       <Form.Item name="feedback">
//                         <TextArea
//                           autoSize={{ minRows: 5 }}
//                           className="w-full border border-gray-500  resize-none p-2 rounded-md"
//                           placeholder="Drop message / concern"
//                         // type="text"
//                         />
//                       </Form.Item>

//                     </div>
//                     <button onClick={handleSubmit} className="border mt-3 bg-[#A17A17] text-white p-2 w-28 rounded-md">
//                       Send
//                     </button>
//                   </div>
//                 </Form>
//               </section>
//               <section className="md:w-1/2 flex justify-center">
//                 <div className="border bg-[#A17A17] md:w-72 md:p-4 p-4  mt-5 items-center text-white rounded-lg">
//                   <span className="text-lg font-semibold">Contact Information</span>
//                   <div className="mt-3 leading-5">
//                     <p className="flex text-xs gap-3">
//                       <IoLocationOutline className="mt-1 w-6 h-6 flex-shrink-0" />
//                       <span>
//                         138, Kutchery RD, Girija Garden, Mylapore, <br />
//                         Chennai-600004, TamilNadu
//                       </span>
//                     </p>
//                   </div>
//                   <div className="text-sm mt-3">
//                     <div className="flex text-xs gap-3 items-start">
//                       <IoCallOutline className="w-5 h-5 flex-shrink-0" />
//                       <div>
//                         <p>044 24985923</p>
//                         <p className="mt-0.5">+91 9159349369</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="text-sm mt-3">
//                     <div className="flex text-xs gap-3 items-start">
//                       <CiMail className="w-5 h-5 flex-shrink-0" />
//                       <div className="break-all">
//                         <p>venkataramanaayurveda@gmail.com</p>
//                         <p className="mt-0.5">vadsales1905@gmail.com</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="flex mt-4 gap-3 justify-start">
//                     <div className="border bg-[#FFF0C0] rounded-3xl h-8 w-8 flex items-center">
//                       <a
//                         href={instagramPageUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <BsInstagram className="mx-2 text-[#A17A17]" />
//                       </a>
//                     </div>
//                     <div className="border bg-[#FFF0C0] rounded-3xl h-8 w-8 flex items-center">
//                       <a href={facebookPageUrl}>
//                         <FaFacebookSquare className="mx-2 text-[#A17A17]" />
//                       </a>
//                     </div>
//                     <div className="border bg-[#FFF0C0] rounded-3xl h-8 w-8 flex items-center">
//                       <a
//                         href={twitterPageUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <FaXTwitter className="mx-2 text-[#A17A17]" />
//                       </a>
//                     </div>
//                     <div className="border bg-[#FFF0C0] rounded-3xl h-8 w-8 flex items-center">
//                       <a
//                         href={linkedinPageUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <FaLinkedin className="mx-2 text-[#A17A17]" />
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </section>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layouts>
//   );
// }

// export default Contact;


import React, { useRef } from "react";
import Layouts from "../../Layouts";

import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { CiMail } from "react-icons/ci";
import {
  IoCallOutline,
  IoLocationOutline,
  IoArrowForwardOutline,
} from "react-icons/io5";

import getin from "../../../Assests/images/get in.jpg";

import { Form, Input, InputNumber, message } from "antd";
import TextArea from "antd/es/input/TextArea";

import ContactService from "../../../Redux/Services/ContactService";

function Contact() {
  const formRef = useRef();

  const facebookPageUrl =
    "https://www.facebook.com/your-facebook-page-url";

  const twitterPageUrl =
    "https://twitter.com/your-twitter-page-url";

  const instagramPageUrl =
    "https://www.instagram.com/your-instagram-page-url";

  const linkedinPageUrl =
    "https://www.linkedin.com/in/the-venkataramana-ayurveda-dispensary-sri-v-krishnaswamy-iyer-charitable-trust-852a503a0/";

  /* =====================================================
      MOBILE NUMBER VALIDATION
  ====================================================== */

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (!allowedKeys.includes(e.key)) {
      if (/^[A-Za-z]$/.test(e.key)) {
        message.error("Alphabetic characters are not allowed.");
      }

      e.preventDefault();
    }
  };

  /* =====================================================
      FORM SUBMIT
  ====================================================== */

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, feedback } =
      formRef.current.getFieldValue();

    if (!name) {
      message.error("Please enter your name");
      return;
    }

    if (!email) {
      message.error("Please enter your email");
      return;
    }

    if (!phone) {
      message.error("Please enter your mobile number");
      return;
    }

    if (!feedback) {
      message.error("Please enter your message");
      return;
    }

    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const payload = {
      address: "string",
      code: "string",
      createdBy: "string",
      createdDate: constructedTime,
      email,
      mobileNumber: phone,
      modifiedBy: "string",
      modifiedDate: constructedTime,
      status: 1,
    };

    try {
      await ContactService.contactUs(payload);

      message.success(
        "Thank You! Our support team will contact you shortly."
      );

      formRef.current.resetFields();
    } catch (e) {
      message.error("Error Occurred");
    }
  };

  return (
    <Layouts>
      <main className="min-h-screen bg-[#FAF8F3] text-gray-800 overflow-x-hidden">

        {/* =====================================================
            HERO SECTION
        ====================================================== */}

        <section className="relative h-[260px] xs:h-[280px] sm:h-[320px] md:h-[360px] lg:h-[400px] overflow-hidden">

          <img
            src={getin}
            alt="Get in touch"
            className="
              absolute
              inset-0
              w-full
              h-full
              object-cover
              object-center
            "
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#3D2818]/45 via-[#3D2818]/45 to-[#3D2818]/75" />

          {/* Decorative circles */}
          <div className="absolute -top-24 -left-24 w-56 h-56 sm:w-72 sm:h-72 rounded-full border border-[#E5C978]/30" />

          <div className="absolute -bottom-28 -right-20 w-64 h-64 sm:w-80 sm:h-80 rounded-full border border-[#E5C978]/30" />

          {/* Hero content */}
          <div className="relative z-10 h-full flex items-center justify-center px-5">

            <div className="text-center text-white max-w-3xl">

              <span className="
                inline-block
                text-[10px]
                xs:text-xs
                sm:text-sm
                font-semibold
                tracking-[0.25em]
                sm:tracking-[0.4em]
                uppercase
                text-[#F2D58B]
              ">
                We Would Love To Hear From You
              </span>

              <h1 className="
                mt-3
                text-3xl
                xs:text-4xl
                sm:text-5xl
                md:text-6xl
                lg:text-7xl
                font-serif
                font-bold
                leading-tight
              ">
                Get in Touch
              </h1>

              <div className="flex items-center justify-center gap-3 mt-3">

                <div className="w-12 sm:w-20 h-[2px] bg-[#D7B65C]" />

                <div className="w-2.5 h-2.5 rotate-45 bg-[#D7B65C]" />

                <div className="w-12 sm:w-20 h-[2px] bg-[#D7B65C]" />

              </div>

              <p className="
                mt-3
                text-xs
                xs:text-sm
                sm:text-base
                md:text-lg
                text-[#F7EEDC]
                leading-6
                sm:leading-7
                max-w-2xl
                mx-auto
              ">
                Have a question, concern, or simply want to connect with us?
                Send us a message and our team will be happy to assist you.
              </p>

            </div>

          </div>
        </section>


        {/* =====================================================
            MAIN CONTACT SECTION
        ====================================================== */}

        <section className="
          w-full
          max-w-7xl
          mx-auto
          px-4
          xs:px-5
          sm:px-8
          lg:px-10
          xl:px-12
          py-12
          sm:py-16
          md:py-20
          lg:py-24
        ">

          <div className="
            grid
            grid-cols-1
            lg:grid-cols-12
            gap-8
            lg:gap-10
            items-stretch
          ">


            {/* =================================================
                CONTACT INFORMATION
            ================================================== */}

            <div className="
              lg:col-span-5
              relative
              overflow-hidden
              rounded-2xl
              sm:rounded-3xl
              bg-[#5C3A21]
              text-white
              shadow-xl
            ">

              {/* Decorative circles */}

              <div className="
                absolute
                -top-20
                -right-20
                w-48
                h-48
                rounded-full
                border
                border-[#D8BD73]/20
              " />

              <div className="
                absolute
                -bottom-28
                -left-24
                w-64
                h-64
                rounded-full
                border
                border-[#D8BD73]/20
              " />

              <div className="
                relative
                z-10
                p-6
                xs:p-7
                sm:p-9
                md:p-10
                lg:p-12
                h-full
                flex
                flex-col
              ">

                {/* Heading */}

                <span className="
                  text-[10px]
                  xs:text-xs
                  sm:text-sm
                  tracking-[0.25em]
                  uppercase
                  font-semibold
                  text-[#E5C978]
                ">
                  Contact Information
                </span>

                <h2 className="
                  mt-3
                  text-2xl
                  xs:text-3xl
                  sm:text-4xl
                  font-serif
                  font-bold
                  text-white
                  leading-tight
                ">
                  Let’s Start a Conversation
                </h2>

                <div className="mt-5 flex items-center gap-3">

                  <div className="w-12 sm:w-16 h-[3px] bg-[#D7B65C]" />

                  <div className="w-2 h-2 rounded-full bg-[#D7B65C]" />

                </div>

                <p className="
                  mt-5
                  text-sm
                  sm:text-base
                  text-[#EBDCC5]
                  leading-7
                ">
                  Whether you have a question about our Ayurvedic services,
                  products, heritage, or would simply like to know more,
                  feel free to reach out to us.
                </p>


                {/* =================================================
                    INFORMATION ITEMS
                ================================================== */}

                <div className="mt-8 space-y-6">

                  {/* Address */}

                  <div className="flex items-start gap-4">

                    <div className="
                      shrink-0
                      w-11
                      h-11
                      rounded-full
                      bg-[#FFF0C0]
                      flex
                      items-center
                      justify-center
                    ">
                      <IoLocationOutline className="text-[#A17A17] text-xl" />
                    </div>

                    <div className="min-w-0">

                      <p className="
                        text-[10px]
                        sm:text-xs
                        uppercase
                        tracking-[0.2em]
                        text-[#E5C978]
                        font-semibold
                      ">
                        Visit Us
                      </p>

                      <p className="
                        mt-1
                        text-sm
                        sm:text-base
                        leading-6
                        text-[#F7EEDC]
                      ">
                        138, Kutchery RD, Girija Garden,
                        Mylapore, Chennai-600004,
                        Tamil Nadu
                      </p>

                    </div>

                  </div>


                  {/* Phone */}

                  <div className="flex items-start gap-4">

                    <div className="
                      shrink-0
                      w-11
                      h-11
                      rounded-full
                      bg-[#FFF0C0]
                      flex
                      items-center
                      justify-center
                    ">
                      <IoCallOutline className="text-[#A17A17] text-xl" />
                    </div>

                    <div>

                      <p className="
                        text-[10px]
                        sm:text-xs
                        uppercase
                        tracking-[0.2em]
                        text-[#E5C978]
                        font-semibold
                      ">
                        Call Us
                      </p>

                      <p className="mt-1 text-sm sm:text-base text-[#F7EEDC]">
                        044 24985923
                      </p>

                      <p className="text-sm sm:text-base text-[#F7EEDC]">
                        +91 9159349369
                      </p>

                    </div>

                  </div>


                  {/* Email */}

                  <div className="flex items-start gap-4">

                    <div className="
                      shrink-0
                      w-11
                      h-11
                      rounded-full
                      bg-[#FFF0C0]
                      flex
                      items-center
                      justify-center
                    ">
                      <CiMail className="text-[#A17A17] text-2xl" />
                    </div>

                    <div className="min-w-0">

                      <p className="
                        text-[10px]
                        sm:text-xs
                        uppercase
                        tracking-[0.2em]
                        text-[#E5C978]
                        font-semibold
                      ">
                        Email Us
                      </p>

                      <p className="
                        mt-1
                        text-sm
                        sm:text-base
                        text-[#F7EEDC]
                        break-all
                      ">
                        vkict1905@gmail.com
                      </p>

                      <p className="
                        text-sm
                        sm:text-base
                        text-[#F7EEDC]
                        break-all
                      ">
                        vadsales1905@gmail.com
                      </p>

                    </div>

                  </div>

                </div>


                {/* =================================================
                    SOCIAL MEDIA
                ================================================== */}

                <div className="mt-auto pt-8">

                  <div className="h-px bg-[#D8BD73]/20 mb-6" />

                  <p className="
                    text-[10px]
                    sm:text-xs
                    uppercase
                    tracking-[0.25em]
                    text-[#E5C978]
                    font-semibold
                  ">
                    Follow Us
                  </p>

                  <div className="flex flex-wrap gap-3 mt-4">

                    {/* Instagram */}

                    <a
                      href={instagramPageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                      className="
                        w-10
                        h-10
                        rounded-full
                        bg-[#FFF0C0]
                        flex
                        items-center
                        justify-center
                        text-[#A17A17]
                        transition-all
                        duration-300
                        hover:-translate-y-1
                        hover:bg-white
                      "
                    >
                      <BsInstagram className="text-lg" />
                    </a>


                    {/* Facebook */}

                    <a
                      href={facebookPageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                      className="
                        w-10
                        h-10
                        rounded-full
                        bg-[#FFF0C0]
                        flex
                        items-center
                        justify-center
                        text-[#A17A17]
                        transition-all
                        duration-300
                        hover:-translate-y-1
                        hover:bg-white
                      "
                    >
                      <FaFacebookSquare className="text-lg" />
                    </a>


                    {/* X */}

                    <a
                      href={twitterPageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="X"
                      className="
                        w-10
                        h-10
                        rounded-full
                        bg-[#FFF0C0]
                        flex
                        items-center
                        justify-center
                        text-[#A17A17]
                        transition-all
                        duration-300
                        hover:-translate-y-1
                        hover:bg-white
                      "
                    >
                      <FaXTwitter className="text-lg" />
                    </a>


                    {/* LinkedIn */}

                    <a
                      href={linkedinPageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                      className="
                        w-10
                        h-10
                        rounded-full
                        bg-[#FFF0C0]
                        flex
                        items-center
                        justify-center
                        text-[#A17A17]
                        transition-all
                        duration-300
                        hover:-translate-y-1
                        hover:bg-white
                      "
                    >
                      <FaLinkedin className="text-lg" />
                    </a>

                  </div>

                </div>

              </div>
            </div>


            {/* =================================================
                CONTACT FORM
            ================================================== */}

            <div className="
              lg:col-span-7
              bg-white
              rounded-2xl
              sm:rounded-3xl
              border
              border-[#EDE4D4]
              shadow-lg
              sm:shadow-xl
              p-6
              xs:p-7
              sm:p-9
              md:p-10
              lg:p-12
              xl:p-14
            ">

              <Form
                ref={formRef}
                className="w-full"
              >

                {/* Form heading */}

                <div>

                  <span className="
                    text-[10px]
                    xs:text-xs
                    sm:text-sm
                    font-semibold
                    tracking-[0.25em]
                    uppercase
                    text-[#A17A36]
                  ">
                    Send Us a Message
                  </span>

                  <h2 className="
                    mt-2
                    text-2xl
                    xs:text-3xl
                    sm:text-4xl
                    md:text-5xl
                    font-serif
                    font-bold
                    text-[#4E321F]
                    leading-tight
                  ">
                    We’re Here to Help
                  </h2>

                  <div className="mt-5 flex items-center gap-3">

                    <div className="w-12 sm:w-16 h-[3px] bg-[#C79A45]" />

                    <div className="w-2 h-2 rounded-full bg-[#C79A45]" />

                  </div>

                  <p className="
                    mt-5
                    text-sm
                    sm:text-base
                    text-gray-600
                    leading-7
                    max-w-xl
                  ">
                    Fill in the details below and share your message with
                    our team. We will get back to you as soon as possible.
                  </p>

                </div>


                {/* =================================================
                    NAME
                ================================================== */}

                <div className="mt-8">

                  <label className="
                    block
                    mb-2
                    text-sm
                    font-semibold
                    text-[#5C3A21]
                  ">
                    Name
                    <span className="text-red-500 ml-1">*</span>
                  </label>

                  <Form.Item
                    name="name"
                    className="mb-0"
                  >
                    <Input
                      placeholder="Enter your name"
                      className="
                        !h-12
                        !rounded-xl
                        !border-[#D9D1C4]
                        hover:!border-[#A17A17]
                        focus:!border-[#A17A17]
                        !text-sm
                        sm:!text-base
                      "
                    />
                  </Form.Item>

                </div>


                {/* =================================================
                    EMAIL + MOBILE
                ================================================== */}

                <div className="
                  mt-5
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  gap-5
                ">

                  {/* Email */}

                  <div>

                    <label className="
                      block
                      mb-2
                      text-sm
                      font-semibold
                      text-[#5C3A21]
                    ">
                      Email
                      <span className="text-red-500 ml-1">*</span>
                    </label>

                    <Form.Item
                      name="email"
                      className="mb-0"
                    >
                      <Input
                        placeholder="Enter your email"
                        className="
                          !h-12
                          !rounded-xl
                          !border-[#D9D1C4]
                          hover:!border-[#A17A17]
                          focus:!border-[#A17A17]
                          !text-sm
                          sm:!text-base
                        "
                      />
                    </Form.Item>

                  </div>


                  {/* Mobile */}

                  <div>

                    <label className="
                      block
                      mb-2
                      text-sm
                      font-semibold
                      text-[#5C3A21]
                    ">
                      Mobile Number
                      <span className="text-red-500 ml-1">*</span>
                    </label>

                    <Form.Item
                      name="phone"
                      className="mb-0"
                    >
                      <InputNumber
                        onKeyPress={handleKeyPress}
                        maxLength={10}
                        controls={false}
                        placeholder="Enter mobile number"
                        className="
                          !w-full
                          !h-12
                          !rounded-xl
                          !border-[#D9D1C4]
                          hover:!border-[#A17A17]
                          focus:!border-[#A17A17]
                          !text-sm
                          sm:!text-base
                        "
                      />
                    </Form.Item>

                  </div>

                </div>


                {/* =================================================
                    MESSAGE
                ================================================== */}

                <div className="mt-5">

                  <label className="
                    block
                    mb-2
                    text-sm
                    font-semibold
                    text-[#5C3A21]
                  ">
                    Message
                    <span className="text-red-500 ml-1">*</span>
                  </label>

                  <Form.Item
                    name="feedback"
                    className="mb-0"
                  >
                    <TextArea
                      autoSize={{
                        minRows: 5,
                        maxRows: 9,
                      }}
                      placeholder="Write your message or concern..."
                      className="
                        !rounded-xl
                        !border-[#D9D1C4]
                        hover:!border-[#A17A17]
                        focus:!border-[#A17A17]
                        !text-sm
                        sm:!text-base
                        !leading-7
                        !resize-none
                      "
                    />
                  </Form.Item>

                </div>


                {/* =================================================
                    SUBMIT BUTTON
                ================================================== */}

                <div className="mt-7 sm:mt-8">

                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="
                      group
                      w-full
                      sm:w-auto
                      min-w-[160px]
                      h-12
                      px-7
                      rounded-xl
                      bg-[#A17A17]
                      hover:bg-[#8B6412]
                      text-white
                      font-semibold
                      text-sm
                      sm:text-base
                      flex
                      items-center
                      justify-center
                      gap-3
                      shadow-md
                      hover:shadow-lg
                      transition-all
                      duration-300
                      cursor-pointer
                    "
                  >
                    <span>Send Message</span>

                    <IoArrowForwardOutline
                      className="
                        text-lg
                        transition-transform
                        duration-300
                        group-hover:translate-x-1
                      "
                    />

                  </button>

                </div>

              </Form>

            </div>

          </div>
        </section>


        {/* =====================================================
            BOTTOM HERITAGE SECTION
        ====================================================== */}

        <section className="
          relative
          bg-[#FFF1C7]
          border-y
          border-[#E5D39C]
          overflow-hidden
        ">

          <div className="
            absolute
            -top-20
            -left-20
            w-48
            h-48
            rounded-full
            border
            border-[#D8BD73]/40
          " />

          <div className="
            absolute
            -bottom-24
            -right-20
            w-56
            h-56
            rounded-full
            border
            border-[#D8BD73]/40
          " />

          <div className="
            relative
            max-w-4xl
            mx-auto
            px-5
            sm:px-8
            py-12
            sm:py-16
            md:py-20
            text-center
          ">

            <span className="
              text-[10px]
              xs:text-xs
              sm:text-sm
              font-semibold
              tracking-[0.25em]
              sm:tracking-[0.35em]
              uppercase
              text-[#8B6B35]
            ">
              The Venkataramana Legacy
            </span>

            <h3 className="
              mt-3
              text-2xl
              xs:text-3xl
              sm:text-4xl
              md:text-5xl
              font-serif
              font-bold
              text-[#5C3A21]
              leading-tight
            ">
              A tradition of care,
              <br className="sm:hidden" />
              compassion & healing.
            </h3>

            <div className="flex items-center justify-center gap-3 mt-5">

              <div className="w-10 sm:w-20 h-[1px] bg-[#C79A45]" />

              <div className="w-2 h-2 rotate-45 bg-[#C79A45]" />

              <div className="w-10 sm:w-20 h-[1px] bg-[#C79A45]" />

            </div>

            <p className="
              mt-5
              text-xs
              sm:text-sm
              md:text-base
              text-gray-700
              leading-7
              max-w-2xl
              mx-auto
            ">
              Established in 1905, The Venkataramana Ayurveda Dispensary
              continues its commitment to preserving and serving the
              timeless traditions of Ayurveda.
            </p>

          </div>

        </section>

      </main>
    </Layouts>
  );
}

export default Contact;